const EmptyOutput = () => {
    return (
        <div className={'w-full md:w-[50%] h-auto border-2 border-black rounded-3xl p-4 md:p-6 flex flex-col'}>
            <div className={'flex space-x-2 md:space-x-4'}>
                <svg width="28" height="29" className="md:w-[35px] md:h-[36px]" viewBox="0 0 35 36" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.6 35.9L14.8 22.1L2.9 29.4L7.45058e-08 24.9L12.4 17.6L0.4 10.4L3.3 6L14.7 13.1L14.6 -4.76837e-06H20L19.9 13L31.2 6L34.2 10.4L22.2 17.6L34.7 24.9L31.6 29.4L19.8 22.1L20 35.9H14.6Z"
                        fill="#E9FA9C"/>
                </svg>
                <h1 className={'text-2xl md:text-4xl'}>Output</h1>
            </div>
            <textarea
                className={'bg-transparent w-full h-4/5 p-2 md:p-4 outline-none border-2 border-zinc-200 rounded-3xl my-2 text-center text-base md:text-lg'}
                placeholder={'output prompt will go here'}
                readOnly={true}
                value={"Click on Render to generate Prompt"}
            >
            </textarea>
        </div>
    );
};

export default EmptyOutput;